import { render, staticRenderFns } from "./OverviewOfParticipantsChart.vue?vue&type=template&id=464bd3ce&"
import script from "./OverviewOfParticipantsChart.vue?vue&type=script&lang=js&"
export * from "./OverviewOfParticipantsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464bd3ce')) {
      api.createRecord('464bd3ce', component.options)
    } else {
      api.reload('464bd3ce', component.options)
    }
    module.hot.accept("./OverviewOfParticipantsChart.vue?vue&type=template&id=464bd3ce&", function () {
      api.rerender('464bd3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OverviewOfParticipantsChart.vue"
export default component.exports